import React from 'react';

import homepage_main from '../../images/videos/homepage-main.webm';
import homepage_changing_screens from '../../images/videos/homepage-changing-screens.webm';
import homepage_edit_schedule from '../../images/videos/homepage-edit-schedule.webm';
import homepage_auto_generate from '../../images/videos/homepage-auto-generate.webm';
import homepage_conflicts from '../../images/videos/homepage-conflicts.webm';
import homepage_admin_reports from '../../images/videos/homepage-admin-reports.webm';

import edario_logo_dark from '../../images/logo-dark.png';

import WebsiteNavbar from './lib/html/WebsiteNavbar';
import WebsiteFooter from './lib/html/WebsiteFooter';
import SisList from './lib/html/SisList';

import '../../css/home_page.css';

export default function HomePage() {
	return (
		<div id='homepage-content'>
			<WebsiteNavbar></WebsiteNavbar>
			<div className='homepage-banner'>
				<div id='homepage-banner-main-inner'>
					<div id='homepage-main-banner'>
						<div>
							<div id='homepage-main-banner-heading'>
								<h1 className='white-text'>Master Scheduling,<br></br>Simplified</h1>
							</div>
							<p className='white-text'>Easily create and edit your master schedule, even with little to no experience.</p>
							<a className='btn blue-btn btn-large' style={{maxWidth:'250px', margin:'50px 0px'}} href='#features'>Learn More</a>
						</div>
						<div id='homepage-video-container'>
							<img src={require('../../images/laptop.png')} alt='Laptop flat'/>
							<video autoPlay={true} loop={true} muted name="Moving section" src={homepage_main}></video>
						</div>
					</div>
				</div>
			</div>
			<div id='features' className='homepage-banner'>
				<h2 className='text-align-center'>Scheduling Made Easy</h2>
				<p className='text-align-center'>Learn why edario is becoming the most popular way to do master scheduling.</p>
				<div className='homepage-feature-container grid-mobilize'>
					<div className='homepage-feature-left'>
						<video className='homepage-feature-video' autoPlay={true} loop={true} muted name="Changing screens" src={homepage_changing_screens}></video>
					</div>
					<div className='homepage-feature-explanation-container homepage-feature-right'>
						<div className='homepage-random-blob pastel-light-turquoise'></div>
						<div className='homepage-feature-title-container'>
							<img className='homepage-feature-title-img' src={edario_logo_dark} alt='Edario Logo' />
							<h3>Step by Step Process</h3>
						</div>
						<p className='homepage-feature-text'>Our Turbo Tax-like screens take you step by step through the scheduling process.</p>
					</div>
				</div>
				<div className='homepage-feature-container grid-mobilize'>
					<div className='homepage-feature-explanation-container homepage-feature-left'>
						<div className='homepage-random-blob pastel-light-purple'></div>
						<div className='homepage-feature-title-container'>
							<img className='homepage-feature-title-img' src={edario_logo_dark} alt='Edario Logo' />
							<h3>Flexible Schedule Building</h3>
						</div>
						<p className='homepage-feature-text'>Whether you have a daily schedule, rotating block schedule, or even something more complicated, our flexible schedule builder can handle it.</p>
					</div>
					<div className='homepage-feature-right'>
						<video className='homepage-feature-video' autoPlay={true} loop={true} muted name="Changing screens" src={homepage_edit_schedule}></video>
					</div>
				</div>
				<div className='homepage-feature-container grid-mobilize'>
					<div className='homepage-feature-left'>
						<video className='homepage-feature-video' autoPlay={true} loop={true} muted name="Auto generate" src={homepage_auto_generate}></video>
					</div>
					<div className='homepage-feature-explanation-container homepage-feature-right'>
						<div className='homepage-random-blob pastel-light-yellow'></div>
						<div className='homepage-feature-title-container'>
							<img className='homepage-feature-title-img' src={edario_logo_dark} alt='Edario Logo' />
							<h3>Powerful Schedule Automation</h3>
						</div>
						<p className='homepage-feature-text'>Our powerful algorithms auto generate thousands of sample schedules and then chooses the best one for you.</p>
					</div>
				</div>
				<div className='homepage-feature-container grid-mobilize'>
					<div className='homepage-feature-explanation-container homepage-feature-left'>
						<div className='homepage-feature-title-container'>
							<div className='homepage-random-blob pastel-light-turquoise'></div>
							<img className='homepage-feature-title-img' src={edario_logo_dark} alt='Edario Logo' />
							<h3>Easy Conflict Resolution</h3>
						</div>
						<p className='homepage-feature-text'>We make it incredibly easy to both understand and fix conflicts, without needing to recreate or rerun a whole new schedule.</p>
					</div>
					<div className='homepage-feature-right'>
						<video className='homepage-feature-video' autoPlay={true} loop={true} muted name="Conflict loop" src={homepage_conflicts}></video>
					</div>
				</div>
				<div className='homepage-feature-container grid-mobilize'>
					<div className='homepage-feature-left'>
						<video className='homepage-feature-video' autoPlay={true} loop={true} muted name="Admin reports" src={homepage_admin_reports}></video>
					</div>
					<div className='homepage-feature-explanation-container homepage-feature-right'>
						<div className='homepage-random-blob pastel-light-purple'></div>
						<div className='homepage-feature-title-container'>
							<img className='homepage-feature-title-img' src={edario_logo_dark} alt='Edario Logo' />
							<h3>Admin Reports</h3>
						</div>
						<p className='homepage-feature-text'>We create reports that are both insightful and interactive, allowing you to edit schedules within the reports themselves!</p>
					</div>
				</div>
			</div>
			<div className='homepage-banner light-gray'>
				<SisList></SisList>
			</div>
			<section className="library-cta">
				<h2>Want to learn more?</h2>
				<p>Book a 45-minute demo to learn more about how we're simplifying master scheduling.</p>
				<a id='library-cta-btn' href="/contact">Book a Demo</a>
			</section>
			<WebsiteFooter></WebsiteFooter>
		</div>
	);
}
